import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { deviceService } from '../../services/api/device.service'
import { useHistory } from 'react-router-dom';
import { deviceConstants } from '../../redux/device/device.constants';
import { setDeviceData, setLogin } from '../../redux/device/device.actions';
import { preLoadImagePath } from '../../helpers/images';
import { FooterComponent } from '../../components/footer/footer.component';
import { headerConstants } from '../../redux/header/header.constants';
import { setHeader } from '../../redux/header/header.actions';
import { AppConstant, DeviceClassEnum } from '../../helpers/constants';
import {initializeAppSession} from "../../services/utilities/sessionInitializer";
import { setAPIError } from '../../redux/error/error.actions';
import { errorConstants } from '../../redux/error/error.constants';
import { sessionManager } from '../../services/utilities/sessionManager';
import { sessionStorageService } from '../../services/utilities/sessionStorageService';

function DevicePage({ match }) {
    const history = useHistory();
    const dispatch = useDispatch();
    const delayInMs = 3000;

    useEffect(() => {
        try {
            // Use React Router params instead of manual URL parsing
            // Route is defined as /device/:uuid, so match.params.uuid is available
            var deviceId = match?.params?.uuid;
            
            // Validate deviceId (UUID format check - basic validation)
            if (!deviceId || deviceId.trim() === '' || deviceId.length < 10) {
                console.warn('Invalid device route: missing or invalid UUID', { deviceId });
                dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
                history.push("/scan");
                return;
            }
            
            deviceInfo(deviceId);
        } catch (exception) {
            console.error('Error in DevicePage useEffect:', exception);
            dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
            history.push("/scan");
        }
    }, [match])


    const deviceInfo = async (deviceId) => {
        if (!deviceId || deviceId.trim() === '') {
            console.warn('Invalid device ID, redirecting to scan');
            dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
            history.push("/scan");
            return;
        }
        
        initializeAppSession();
        console.debug(`Retrieving device info for device ${deviceId}`);
        var data = await deviceService.getDeviceByUUID(deviceId);
        
        // Check if API returned an error object (timeout, network_error, etc.)
        if (data && typeof data === 'object' && data.error) {
            console.warn('API error detected:', data.error, data.message);
            // Cleanup session data on API error (IKKE telefonnummer)
            try {
                sessionStorageService.removeDeviceUuid();
                sessionManager.clearSession();
            } catch (e) {
                console.warn('Failed to clean up storage on API error (non-blocking)', { error: e });
            }
            // Check if it's a timeout error (400)
            var isTimeout = data.error === 'timeout';
            dispatch(setAPIError(errorConstants.SET_ERROR_API, true, true, isTimeout ? 400 : null));
            dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
            history.push("/scan");
            return;
        }
        
        // If API returns error (string) or null, redirect to scan with login page active
        if (data === null || data === "" || typeof (data) === 'string') {
            console.warn('Device not found or invalid, redirecting to scan');
            dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
            history.push("/scan");
            return;
        }
        
        // Check if data has required properties (device and store)
        if (typeof (data) != 'string' && data.device && data.store) {
            var payload = {
                device: data.device,
                store: data.store
            }
            
            var deviceTypeClass = payload.device?.deviceType?.deviceClass.toLowerCase();
            dispatch(setDeviceData(deviceConstants.SET_DEVICEINFO, payload));
            dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
            console.debug(`Successfully retrieved info. Device type class: ${deviceTypeClass}`);

            if (deviceTypeClass === DeviceClassEnum.gateAccess.toLowerCase()) {
                dispatch(setHeader(headerConstants.SET_HEADER_GREET, true));
            } else {
                // Device-endepunktet skal kun brukes til å hente device-info, ikke til å indikere autentisering
                // Hvis det er en feil (f.eks. device offline eller utenfor åpningstid), vis den
                // Men sett ALDRI pageType = success basert på Device-endepunktet
                // Success skal kun settes etter faktisk Vipps-autentisering
                if (data.errorMessage && data.errorMessage.trim() !== '') {
                    // Det er en feil - vis den
                    var userInfo = {
                        loginType: AppConstant.deviceClassName,
                        pageType: AppConstant.error,
                        message: data.errorMessage,
                        contact: data.contact,
                        device_instruction: data.device_instruction,
                        contact_instruction: data.contact_instruction,
                        name: ''
                    }

                    console.debug(`Device validation error detected: ${data.errorMessage}`);
                    document.getElementById("root").classList.add(deviceTypeClass);
                    dispatch(setHeader(headerConstants.SET_HEADER, true, userInfo));
                    console.debug('Device validation error. Routing to home.');
                    history.push("/home");
                    return;
                } else {
                    // Device er gyldig og klar - men dette betyr IKKE at døren er låst opp
                    // Vi skal bare redirecte til scan-siden for å starte Vipps-autentisering
                    // Ikke sett userInfo i Redux med pageType = success
                    console.debug('Device is valid and ready. Redirecting to scan page for Vipps authentication.');
                    dispatch(setHeader(headerConstants.SET_HEADER_GREET, true));
                }
            }

            setTimeout(() => {
                console.debug(`Routing to scan after timeout for device ${deviceId}`);
                history.push("/scan");
            }, delayInMs);
        }
    }

    return (
        <>
            <div id="splash-header">
                <img src={`${preLoadImagePath.mobile}`} alt="" className="w-100" />
            </div>
            <div id="warpper-body" className="hight-auto">
                <div id="slogan" className="d-flex align-item-center justify-content-between flex-direction-colomn h-100">
                    <div className="vipps-wrapper">
                        <h1>Lås opp</h1>
                        <h1>med <span className="orange-vipps"> vipps </span> </h1>
                    </div>
                    <p>Vi finner døren du ønsker å åpne.</p>
                    <div className="d-flex align-item-center flex-direction-colomn gap-3">
                        <img src={`${preLoadImagePath.loader}`} width="32" alt="" />
                    </div>
                </div>
            </div>
            <FooterComponent />
        </>
    )
}

export { DevicePage }